export default {"src":"/_next/static/media/rightBlack.d5046d0e.svg","height":2,"width":91,"blurWidth":0,"blurHeight":0};